import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useState } from "react";

import { ApiContext, NavigationContext, UserContext } from "../contexts";
import { IconName, RoutePath } from "../types";
import Icon from "./Icon";

const FooterNav = observer(() => {
  const apiContext = useContext(ApiContext);
  const userContext = useContext(UserContext);
  const navContext = useContext(NavigationContext);

  const [offerTickerValue, setOfferTickerValue] = useState(0);

  useEffect(() => {
    if (userContext.selectedSpecialOffer || (userContext.selectedPromotion &&  ["dollar_off_home_plus_no_additional_cost","dollar_amount_bonus","dollar_amount_bonus_plus_floorplan_options"].includes(userContext.selectedPromotion.type))) {
      setOfferTickerValue(userContext.totalPrice);
    }else if(userContext.selectedPromotion && userContext.selectedPromotion.type === "price_reduction"){
      navContext.setOfferTickerVisible(false);
    }
  }, [navContext.offerTickerVisible, userContext.selectedSpecialOffer, userContext.selectedPromotion]);

  const onClickLogin = () => {
    navContext.setNextButtonEnabled(false);
    navContext.goTo(RoutePath.LOGIN);
  };

  const onClickBack = () => {
    if (navContext.backBtnOnClick) {
      navContext.backBtnOnClick();
    } else {
      if (navContext.onNavigateBack) {
        navContext.onNavigateBack();
      }
      navContext.goBack();
    }
  };
  const onClickNextBtn = () => {
    navContext.setOfferTickerVisible(false);
    if (navContext.nextBtnOnClick) {
      navContext.nextBtnOnClick();
    } else {
      navContext.setNextButtonEnabled(false);
      navContext.goNext();
    }
  };

  const onClickRestart = () => {
    const result = confirm(
      "Are you sure you want to restart? All current selections will be lost."
    );
    if (result) {
      navContext.goTo(RoutePath.HOME);
      userContext.reset();
      apiContext.reset();
    }
  };

  const onClickFooterCenter = () => {
    const $footerCenter = $(".footer-center");
    const $breakdownContent = $footerCenter.find(".breakdown-content");
    if($footerCenter){
      if($footerCenter.hasClass("active")){
        $footerCenter.removeClass("active");
        $breakdownContent.slideUp();
      }else{
        $footerCenter.addClass("active");
        $breakdownContent.slideDown();
      }
    }
  };

  if (!navContext.footerNavVisible) {
    return <></>;
  }

  return (
    <div className={"footer-nav"} data-price={userContext.subtotalPrice} data-offer={offerTickerValue}>
      <div className={"container"}>
        <div className={"footer-left"}>
          {navContext.backBtnVisible && (
            <div className={"back-btn-container"}>
              <button className={"btn btn-black back-btn"} onClick={onClickBack}>
                <Icon name={IconName.ARROW} />
                <span>Back</span>
              </button>
            </div>
          )}
          {navContext.restartBtnVisible && (
            <div className={"restart-btn-container"}>
              <button
                className={"btn btn-black restart-btn"}
                onClick={onClickRestart}
              >
                <Icon name={IconName.RESTART} />
                <span>Restart</span>
              </button>
            </div>
          )}
          {navContext.loginBtnVisible && (
            <button className={"btn btn-black login-btn"} onClick={onClickLogin}>
              Already have an account? Login Now
            </button>
          )}
        </div>
        {navContext.subtotalVisible && (
          <div className={![RoutePath.SPECIAL_OFFERS, RoutePath.FINAL_DETAILS].includes(navContext.currentRoute) ? "footer-center state-nsw" : "footer-center"}
            onClick={onClickFooterCenter}>
            {![RoutePath.SPECIAL_OFFERS, RoutePath.FINAL_DETAILS].includes(navContext.currentRoute) && (
              <div className={"breakdown"}>
                <div className={"breakdown-label"}><span>view cost breakdown</span><Icon name={IconName.CHEVRON_UP_WHITE} /></div>
                <div className={"breakdown-content"}>
                  <div className={"breakdown-row"}>
                    <span className={"breakdown-row-label"}>Base Price</span>
                    <span className={"breakdown-row-value"}>${userContext.basePrice.toLocaleString()}</span>
                  </div>
                  <div className={"breakdown-row"}>
                    <span className={"breakdown-row-label"}>Additional Selections</span>
                    <span className={"breakdown-row-value"}>${(userContext.totalPrice - userContext.basePrice).toLocaleString()}</span>
                  </div>
                </div>
              </div>
            )}
            <span className={"subtotal-title"}>Subtotal</span>
            {[RoutePath.SPECIAL_OFFERS, RoutePath.FINAL_DETAILS].includes(navContext.currentRoute) && (
              <span className={"subtotal-sep"}>:</span>
            )}
            <span className={"subtotal-price"}>
              ${userContext.totalPrice.toLocaleString()}
            </span>
          </div>
        )}
        { navContext.offerTickerVisible && (
          <div
            className={"offer-subtract-ticker"}
          >
            <p className={"ticker-title"}>Applying your Promotion Discount!</p>
            <p className={"ticker-strikethrough"}>${userContext.subtotalPrice.toLocaleString()}</p>
            <p className={"ticker-total"}>${offerTickerValue.toLocaleString()}</p>
          </div>
        )}
        <div className={"footer-right"}>
          {navContext.nextBtnVisible ? (
            <div className={"next-btn-container"}>
              <button
                className={"btn next-btn"}
                onClick={onClickNextBtn}
                disabled={!navContext.nextBtnEnabled}
              >
                {!navContext.nextBtnText ? (
                  <>
                    <Icon name={IconName.ARROW} />
                    <span>{"Next"}</span>
                  </>
                ) : (
                  navContext.nextBtnText
                )}
              </button>
            </div>
          ) : (
            <div className={"next-btn-container"} />
          )}
        </div>
      </div>
    </div>
  );
});

export default FooterNav;
